import { Button, Flex, Text } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { useTranslation } from "../../i18n/LanguageContext";
import { trackUmamiEvent } from "../../lib/analytics/umami";

export default function CallToAction() {
  const { t } = useTranslation();

  return (
    <Flex
      as="section"
      aria-label={t("cta.aria")}
      fontSize={"35px"}
      alignItems={"center"}
      flexDirection={"column"}
      py={"50px"}
      px={"20px"}
      pb={"100px"}
      fontWeight={"500"}
      gap={"20px"}
    >
      <Flex alignItems={"center"} flexDirection={"column"}>
        <Text as="h2" fontSize={"35px"} fontWeight={"500"}>
          {t("cta.title")}
        </Text>
        <Text textAlign={"center"}>
          <Text as={"span"}>{t("cta.planPrefix")}</Text>
          <Text as={"span"} color={"fill.coral"}>
            {t("cta.free")}
          </Text>
          <Text as={"span"}>!</Text>
        </Text>
      </Flex>
      <Flex flexDirection={"column"} alignItems={"center"}>
        <Link
          to={process.env.REACT_APP_BIBLIONA_URL}
          target="_blank"
          onClick={() => trackUmamiEvent("cta_click", { location: "home_cta", cta: "start_free" })}
        >
          <Button variant={"coralFill"}>{t("cta.startFree")}</Button>
        </Link>
        <Link
          to="/pricing"
          onClick={() => trackUmamiEvent("navigation_click", { location: "home_cta", destination: "pricing" })}
        >
          <Button variant={"coralTransparent"}>{t("cta.seePricing")}</Button>
        </Link>
      </Flex>
    </Flex>
  );
}
